import React                     from 'react';
import { Observe }               from 'rewire-core';
import {
  WithStyle,
  // editor,
  // arraySearch,
 }                               from 'rewire-ui';
import classNames                from 'classnames';
import Button                    from '@material-ui/core/Button';
import Typography                from '@material-ui/core/Typography';
import Icon                      from '@material-ui/core/Icon';
import { Theme, makeStyles }     from '@material-ui/core/styles';
import Breadcrumbs               from '../main-navigation/Breadcrumbs';
import MainContentToolbar        from '../main-navigation/MainContentToolbar';
import mainPageModel             from '../main-navigation/MainPageModel';
import { MessageLevel }          from '../DataTypes';
import MainDateRangeNav          from '../ui/MainDateRangeNav';
import MessageIcon               from '../ui/MessageIcon';
import ScheduleControls          from './ScheduleControls';
import scheduleControlsModel     from './ScheduleControlsModel';
import scheduleModel             from './ScheduleModel';
import { withStyles }            from '../utility/styles';

const validationMessageCountStyles = (theme: Theme) => ({
  root: {
    minWidth: '0px',
    minHeight: '0px',
    marginRight: '5px',
    padding: '5px',
    border: `2px solid transparent`,
    '&:last-child': {
      marginRight: '0px',
    },
  },
  countText: {
    marginLeft: '4px',
  },
  messageIcon: {
  },
  messageIconIcon: {
    fontSize: '1.35rem',
  },
  toggledOn: {
    border: `2px solid ${theme.palette.dialogPrimary.main}`,
  },
});

const useValidationMessageCountStyles = makeStyles(validationMessageCountStyles);

function getToggleMessageLevelFilterFn(level: MessageLevel) {
  // toggle message level filters
  return () => {
    if (!scheduleControlsModel.scheduleFilters.levels) {
      scheduleControlsModel.scheduleFilters.levels = [level];
    } else {
      const idx = scheduleControlsModel.scheduleFilters.levels.findIndex((l: MessageLevel) => l === level);
      if (idx < 0) {
        scheduleControlsModel.scheduleFilters.levels.push(level);
      } else if (scheduleControlsModel.scheduleFilters.levels.length <= 1) {
        delete scheduleControlsModel.scheduleFilters.levels;
      } else {
        scheduleControlsModel.scheduleFilters.levels.splice(idx, 1);
      }
    }

    scheduleControlsModel.apply();
  };
}

const ValidationMessageCount = (props: {level: MessageLevel}) => {
  const classes = useValidationMessageCountStyles();

  return <Observe render={() => {
    const count     = scheduleModel.messageCountsPollingModel[`${props.level}MessagesCount`];
    const toggledOn = !!scheduleControlsModel.scheduleFilters.levels?.some((l: MessageLevel) => l === props.level);
    return (
      <Button className={classNames(classes.root, toggledOn ? classes.toggledOn : undefined)} onClick={getToggleMessageLevelFilterFn(props.level)}>
        <MessageIcon level={props.level} className={classes.messageIcon} classes={{icon: classes.messageIconIcon}} tooltip={`${count} ${props.level}`} />
        <Typography className={classes.countText}>{count}</Typography>
      </Button>
    );
  }} />;
};

// ******************* //

const validationMessageCountsStyles = (_theme: Theme) => ({
  root: {
    display: 'flex',
    margin: '0px 15px 7px 0px',
  },
});

const useValidationMessageCountsStyles = makeStyles(validationMessageCountsStyles);

const ValidationMessageCounts = () => {
  const classes = useValidationMessageCountsStyles();

  return <Observe render={() => (
    <div className={classes.root}>
      <ValidationMessageCount level='error' />
      <ValidationMessageCount level='warning' />
      <ValidationMessageCount level='info' />
      <ValidationMessageCount level='success' />
    </div>
  )} />;
};

// ******************* //

const styles = (theme: Theme) => ({
  left: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: '0 1 auto',
    flexWrap: 'wrap',
    marginRight: '10px',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    flex: '0 1 auto',
  },
  button: {
    textTransform: 'none',
    minWidth: '0px',
    flex: '0 0 auto',
    marginRight: '5px',
    marginBottom: '7px',
    height: '33px',
    '&:last-child': {
      marginRight: '0px',
    },
  },
  autoScheduleButton: {
    padding: '6px 10px',
    backgroundColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
    }
  },
});

interface IScheduleToolbarProps {
}

type ScheduleToolbarProps = WithStyle<ReturnType<typeof styles>, IScheduleToolbarProps>;

class ScheduleToolbar extends React.PureComponent<ScheduleToolbarProps> {
  constructor(props: ScheduleToolbarProps) {
    super(props);
  }

  addJob = () => {
    scheduleModel.addJob();
  };

  autoSchedule = () => {
    scheduleModel.autoSchedule();
  };

  render() {
    const {classes} = this.props;

    return <Observe render={() => (
      <MainContentToolbar>
        <div className={classes.left}>
          <Breadcrumbs />
          <MainDateRangeNav />
        </div>
        <div className={classes.right}>
          <Button title='Auto Schedule' className={classNames(classes.button, classes.autoScheduleButton)} variant='contained' onClick={this.autoSchedule} disabled={!scheduleModel.canAutoSchedule()}>
            <Icon className='electric_bolt'>{'electric_bolt'}</Icon>
          </Button>
          <ValidationMessageCounts />
          <Button className={classes.button} variant='contained' onClick={this.addJob} disabled={!mainPageModel.canAddJobs || !(scheduleControlsModel.mode === 'group')}>
            <Icon className='add'>{'add'}</Icon>
            {scheduleModel.viewMode === 'Job' ? 'Add Job' : 'Add Employee / Job'}
          </Button>
          <ScheduleControls />
        </div>
      </MainContentToolbar>
    )} />;
  }
}

export default withStyles<IScheduleToolbarProps>(styles, ScheduleToolbar);
